const pl = {
    accepted: 'Pole :attribute musi być zaakceptowane.',
    after: 'Pole :attribute musi być datą po :after',
    after_or_equal: 'Data w polu :attribute musi być mniejsza lub równa :after_or_equal.',
    alpha: 'Pole :attribute może zawierać tylko litery.',
    alpha_dash: 'Pole :attribute może zawierać tylko znaki alfanumeryczne, myślinki oraz podkreślenia.',
    alpha_num: 'Pole :attribute może zawierać tylko znaki alfanumeryczne.',
    attributes: {},
    before: 'Data w polu :attribute musi być przed :before',
    before_or_equal: 'Data w polu :attribute musi być większa lub równa :before_or_equal.',
    between: {
        numeric: 'Pole :attribute musi zawierać się w przedziale od :min do :max.',
        string: 'Pole :attribute musi zawierać się pomiędzy :min i :max znaków.',
    },
    confirmed: 'Pole :attribute nie zostało potwierdzone.',
    email: 'Pole :attribute nie jest prawidłowym formatem adresu e-mail.',
    date: 'Pole :attribute nie jest prawidłowym formatem daty.',
    def: 'Pole :attribute zawiera błędy.',
    digits: 'Pole :attribute musi zawierać następującą ilość cyfr :digits.',
    digits_between: 'Pole :attribute musi zawierać się pomiędzy :min i :max cyfr.',
    different: 'Pola :attribute i :different muszą się różnić.',
    in: 'Wybrane pole :attribute nie jest prawidłowe.',
    integer: 'Pole :attribute musi być liczbą całkowitą.',
    hex: 'Pole :attribute musi być w systemie szesnastkowym.',
    min: {
        numeric: 'Pole :attribute musi wynosić co najmniej :min.',
        string: 'Pole :attribute musi zawierać co najmniej :min znaków.',
    },
    max: {
        numeric: 'Pole :attribute nie może wynosić więcej niż :max.',
        string: 'Pole :attribute nie może zawierać więcej niż :max znaków.',
    },
    not_in: 'Wybrane pole :attribute nie jest prawidłowe.',
    numeric: 'Pole :attribute musi być liczbą.',
    present: 'Pole :attribute musi być obecne (ale może być puste).',
    required: 'Pole :attribute jest wymagane.',
    required_if: 'Pole :attribute jest wymagane, jeśli pole :other jest równe :value.',
    required_unless: 'Pole :attribute jest wymagane, jeśli pole :other nie jest równe :value.',
    required_with: 'Pole :attribute jest wymagane, jeśli pole :other nie jest puste.',
    required_with_all: 'Pole :attribute jest wymagane, jeśli pola :fields nie są puste.',
    required_without: 'Pole :attribute jest wymagane, jeśli pole :field jest puste.',
    required_without_all: 'Pole :attribute jest wymagane, jeśli pola :fields są puste.',
    same: 'Pola :attribute i :same muszą być takie same.',
    size: {
        numeric: 'Pole :attribute musi być równe :size.',
        string: 'Pole :attribute musi zawierać :size znaków.',
    },
    string: 'Pole :attribute musi być ciągiem znaków.',
    url: 'Pole :attribute musi być prawidłowym adresem URL.',
    regex: 'Pole :attribute nie spełnia warunku.',
};
export default pl;
